export const VALIDATE_INTERNAL_AREA_SLUG = 'internal_area'